module.exports = __webpack_public_path__ + "images/emoji/barber.39a9dde24816928210b5.png";